import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useContext as s } from "react";
import { Box as c } from "../box/Box.js";
import { identity as d } from "../util/index.js";
import { ChartCoreContext as x } from "./ChartCoreContext.js";
import { TooltipContext as h } from "./TooltipContext.js";
import { getColorClassName as f } from "./chartUtils.js";
import { twMerge as t } from "tailwind-merge";
const j = (l) => {
  const { payload: i } = l, { label: o } = s(h), { valueFormatter: m = d } = s(x);
  return i.length === 0 ? null : /* @__PURE__ */ r(c, { className: "text-sm", children: [
    o && /* @__PURE__ */ e("div", { className: t("border-b border-inherit px-4 py-2"), children: /* @__PURE__ */ e("p", { className: t("font-medium text-gray-900"), children: o }) }),
    /* @__PURE__ */ e("div", { className: t("flex flex-col gap-1 px-4 py-2"), children: i.map(({ value: n, category: a, color: p }) => /* @__PURE__ */ r("div", { className: "flex items-center justify-between gap-x-8", children: [
      /* @__PURE__ */ r("div", { className: "flex items-center space-x-2", children: [
        /* @__PURE__ */ e(
          "span",
          {
            "aria-hidden": "true",
            className: t(
              "h-[3px] w-3.5 shrink-0 rounded-full",
              f(p, "bg")
            )
          }
        ),
        /* @__PURE__ */ e("p", { className: t("whitespace-nowrap text-right text-gray-700"), children: a })
      ] }),
      /* @__PURE__ */ e("p", { className: t("whitespace-nowrap text-right font-medium text-gray-900"), children: m(n) })
    ] }, `list-item-${a}`)) })
  ] });
};
export {
  j as ChartTooltip
};
